import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import endpointList from '../../config/endpointList.jsx';

// Async Thunk to Fetch Both APIs
export const fetchFonts = createAsyncThunk(
  'fonts/fetchFonts',
  async () => { 
    try {
      const [adminRes, googleRes] = await Promise.all([
        fetch(endpointList.getAdminfonts),
        fetch(endpointList.getGooglefonts),
      ]);
      
      const adminFontsdata = await adminRes.json(); 
      const adminFonts =  adminFontsdata.data || []; 
      const googleData = await googleRes.json();
      const googleFonts =googleData.items || []// Extract fonts from Google API
 
      // Combine both font lists
      const combinedFonts = [...adminFonts, ...googleFonts];
      console.log("Combined fonts:", combinedFonts);
      
      return combinedFonts;
      
    } catch (error) {
        console.log ("errorinfont",error)
      throw new Error(error.message);
    }
  }
);

// Redux Slice
const fontsSlice = createSlice({
  name: 'fonts',
  initialState: {
    fonts: [],
    status: 'idle',
    error: null,
    isLoaded: false,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFonts.pending, (state) => {
        state.status = 'loading';
        state.isLoaded = false;
      })
      .addCase(fetchFonts.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.fonts = action.payload; // Store combined fonts
        state.isLoaded = true;
      })
      .addCase(fetchFonts.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.isLoaded = false;
      });
  },
});

export default fontsSlice.reducer;
